import React from 'react';

// Constants
import { CompanyEmailAddress } from '../../utils/constants/Constants';

// Data
import { contactPagePinsArray } from '../../utils/data/ContactPagePinsData';

function ContactPageMainContainer() {
  return (
    <main role='main' className='grid gap-12 lg:gap-24 pt-12 mb-20'>
      {/* Contact Info (email text stays at top) */}
      <section className='grid gap-y-4 text-center text-xl px-8'>
        <div>
          <a
            href={`mailto:${CompanyEmailAddress}`}
            className='block break-words whitespace-normal overflow-hidden'
          >
            Email Now: <br />
            <span className='text-sm lg:text-base'>{CompanyEmailAddress}</span>
          </a>
        </div>
      </section>

      {/* Unified pins (ONE map) */}
      <section className='py-6 grid md:grid-flow-col w-fit mx-auto gap-8'>
        {contactPagePinsArray.map((site, index) => (
          <a
            key={index}
            href={site.url}
            target={site.url.startsWith('mailto:') ? undefined : '_blank'}
            rel='noopener noreferrer'
            className='px-6 rounded-lg transition-transform transform hover:scale-105'
          >
            <div className='grid justify-center h-fit'>
              {typeof site.icon === 'string' ? (
                <img
                  src={site.icon}
                  alt={`${site.name} Icon`}
                  className='h-16'
                  loading='lazy'
                />
              ) : (
                <span className='text-colour8'>{site.icon}</span>
              )}
            </div>

            <div className='text-center'>
              <p className='text-2xl font-newsweekly text-colour1'>{site.name}</p>
            </div>
          </a>
        ))}
      </section>
    </main>
  );
}

export default ContactPageMainContainer;
